import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboGrupa from "../../helpers/InputComboGrupaE";
import InputPESEL from "../../helpers/InputPESEL";
import InputDate from "../../helpers/InputDate";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";
import InputCombo from "../../helpers/InputCombo";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";

import back from "../../back.png";

function KidShow(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const [filterParam, setFilterParam] = useState({   

        id: props.row.id,

        d_imie_nazwisko:  '',
        r_imie_nazwisko:  '', 
        p_grupa_id: '_x_',
        archiwalne:  '0',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });



    var def_op_select = 1;


    if(props.row.rodzice.length > 1)
        {
            if(props.row.rodzice[1].prowadzenie_salda == '1') def_op_select = 2;
        }

    const [row, setRowX] = useState({
       
        id: props.row.id,

        p_grupa_id: props.row.p_grupa_id,
        imie:  props.row.imie,        
        imie2:  props.row.imie2,    
        nazwisko: props.row.nazwisko,
        
        info_e: "",


        rdz1_id: props.row.rodzice[0].id,
        rdz1_imie: props.row.rodzice[0].imie,
        rdz1_nazwisko: props.row.rodzice[0].nazwisko,
        rdz1_email: props.row.rodzice[0].e_mail_kontakt,
        rdz1_telefon: props.row.rodzice[0].telefon_kontaktowy,
       
        rdz2_id: props.row.rodzice[1].id,
        rdz2_imie: props.row.rodzice[1].imie,
        rdz2_nazwisko: props.row.rodzice[1].nazwisko,
        rdz2_email: props.row.rodzice[1].e_mail_kontakt,
        rdz2_telefon: props.row.rodzice[1].telefon_kontaktowy,
       
        osoby_upowaznione: props.row.osoby_upowaznione,


    });
    var tmpRow = row;


    const [checked1, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked1);
      };

     

      const [checkedR1, setCheckedR1] = useState(false);
      const handleChangeR1 = () => {
            setCheckedR1(!checkedR1);
          };     
     

      var optionSaldo = [
        {
            v: '_x_',
            title: 'Wybierz'
        },
        {
            v: '1',
            title: 'Opiekun lub rodzic nr 1'
        },
        {
            v: '2',
            title: 'Opiekun lub rodzic nr 2'
        },
      ];


      var optionRach = [       
        {
            v: '0',
            title: 'Pomiń - Brak umowy z bankiem'
        },
        {
            v: '1',
            title: 'Tak - indywidualny numer rachunku do wpłat'
        },
      ];


    const valChecker = (fields) => {

        var allValid = true;

              
        

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = "";

            tmpRow[tabName] = tRef;     
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  

            //setRowX( {...row, [tabName]:tRef } );   
            return;
        }

      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
    }   


    const goNextNew = () => {
        //console.log("goNext");
        saveData();
    }

  
    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,kids', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        //setTab(res.result);             
                        //setRowX(res.result[0]); 
                        //   uq_numer_rachunku: props.row.uq_numer_rachunku,


                        setRowX(  {...row, ["uq_numer_rachunku"]: res.result[0].uq_numer_rachunku  } );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }
    
    const saveData = () => {


         
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

      

        

        var req = row;

        fetch( Config.url + '/rest_v1_kids,kid_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Dane zostały zapisane", "ok" , null);         
                        
                        getTab();
                        //Config.removeFromBuffer( Config.cache_kids_search, props.userData );                        
                        //props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 

    return (

            <div className="view_content">
                    

                    <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">{row.imie} {row.imie2} {row.nazwisko}
                            
                            </div>
                            
                                            

                            
                                    

                        </div>

                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Opiekunowie</div>
                            <div className="form_control">
                            Imię i nazwisko: {row.rdz1_imie} {row.rdz1_nazwisko}
                            </div>
                            
                            <div className="form_control">
                            Kontakt: <a href={'tel:'+row.rdz1_telefon}>{row.rdz1_telefon}</a> / {row.rdz1_email}
                            </div>
                            
                            <div className="form_control">
                            Nr dowodu: {row.rdz1_nr_dowodu}
                            </div>


                            
                        </div>


                        {row.rdz2_imie.length>0 &&
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Opiekunowie</div>
                            
                            <div className="form_control">
                            Imię i nazwisko: {row.rdz2_imie} {row.rdz1_nazwisko}
                            </div>
                            
                            <div className="form_control">
                            Kontakt: <a href={'tel:'+row.rdz2_telefon}>{row.rdz2_telefon}</a> / {row.rdz2_email}
                            </div>
                            

                            <div className="form_control">
                            Nr dowodu: {row.rdz2_nr_dowodu}
                            </div>
                        </div>
                        }
                        

                            <div className="form_tab">


                                    <div className="form_tab_title">Osoby upoważnione do odbioru dziecka</div>

                                    {
                                            row.osoby_upowaznione.map( (osb, rI) => {
                                                                        
                                                if(osb.id>0)
                                                {
                                                    return <div >
                                                        
                                                        <div className="form_control">
                                                        {osb.imie} {osb.nazwisko}
                                                        </div>

                                                        <div className="form_control">
                                                        Pokrewieństwo: {osb.stopien_pokrewienstwa} 
                                                        </div>
                                                        
                            
                                                        <div className="form_control">
                                                        Nr dowodu: {osb.nr_dowodu_4_ost_znaki}
                                                        </div>
                                                        <div className="form_control">
                                                        Telefon:  <a href={'tel:'+osb.numer_telefonu}>{osb.numer_telefonu}</a>
                                                        </div>
                                                    </div>
                                             }
                                                
                                                
                                            } )
                                        }
                                    

                            </div>







                            




 

                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn btn_back" onClick={props.onBack}    > wróć</div>
                            </div>




                    </form>


            </div>
    )

}


export default KidShow;


